import React, { useState } from 'react';
import { submitFeedback } from '../../services/api';

const FeedbackSection = () => {
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null); // { text: string, type: 'success' | 'error' }
  const [remainingChars, setRemainingChars] = useState(2000);

  const MIN_LENGTH = 10;
  const MAX_LENGTH = 2000;

  const handleFeedbackChange = (e) => {
    const text = e.target.value;
    if (text.length <= MAX_LENGTH) {
      setFeedback(text);
      setRemainingChars(MAX_LENGTH - text.length);
    }
  };

  const handleSubmit = async () => {
    // Validation
    if (feedback.trim().length < MIN_LENGTH) {
      setMessage({
        text: `Feedback must be at least ${MIN_LENGTH} characters long.`,
        type: 'error'
      });
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    try {
      const response = await submitFeedback(feedback.trim());
      
      if (response.data.success) {
        setMessage({
          text: response.data.message || 'Thank you for your feedback!',
          type: 'success'
        });
        setFeedback(''); // Clear textarea
        setRemainingChars(MAX_LENGTH);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'An error occurred. Please try again later.';
      setMessage({
        text: errorMessage,
        type: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg p-6">

{/*        */}{/* Divider */}
{/*       <div className="border-t border-gray-700 my-6"></div> */}
      {/* Beta Badge and Title */}
      <div className="flex items-center justify-center mb-4">
        <span className="bg-yellow-500 text-gray-900 text-xs font-bold px-2 py-1 rounded mr-2">
          BETA
        </span>
        <h3 className="text-xl font-bold text-white">We're in Beta - Your Feedback Matters!</h3>
      </div>

      {/* Description */}
      <p className="text-gray-300 text-center mb-4">
        Help us improve! Share your thoughts, report bugs, or suggest features:
      </p>

      {/* Feedback Textarea */}
      <div className="mb-4">
        <textarea
          value={feedback}
          onChange={handleFeedbackChange}
          placeholder="Type your feedback here..."
          className="w-full bg-gray-700 text-white rounded-lg p-3 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
          disabled={isSubmitting}
        />
        <div className="flex justify-between items-center mt-2">
          <span className={`text-sm ${remainingChars < 100 ? 'text-yellow-400' : 'text-gray-400'}`}>
            {remainingChars} characters remaining
          </span>
          <span className="text-sm text-gray-500">
            Min {MIN_LENGTH} chars
          </span>
        </div>
      </div>

      {/* Submit Button */}
      <button
        onClick={handleSubmit}
        disabled={isSubmitting || feedback.trim().length < MIN_LENGTH}
        className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed mb-4"
      >
        {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
      </button>

      {/* Success/Error Message */}
      {message && (
        <div className={`p-4 rounded-lg mb-4 ${message.type === 'error' ? 'bg-red-600' : 'bg-green-600'} text-white text-center`}>
          {message.text}
        </div>
      )}


    </div>
  );
};

export default FeedbackSection;
